
import _ from 'lodash';
import ElCustomColorPicker from '@com/components/vue-colorpicker/index.vue';

export default {
  components: {
    ElCustomColorPicker: ElCustomColorPicker
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },

  computed: {
    color: function color() {
      return _.get(this.model, this.config.prop);
    }
  },

  methods: {
    handleChange: function handleChange(val) {
      // 动态组件数据变更后要更新
      this.$emit('update-field', { prop: this.config.prop, value: val });
    }
  }
};